// src/components/layout/AdminSidebar.jsx
import React from "react";
import AdminPortalSidebar from "./AdminPortalSidebar";

const AdminSidebar = ({ isOpen, onClose }) => (
  <AdminPortalSidebar
    isOpen={isOpen}
    onClose={onClose}
    basePath="/admin"
    dashboardPath="/admindashboard"
    portalLabel="ADMIN PORTAL"
  />
);

export default AdminSidebar;
